import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetBusinessListLink(): string {
  const countryCode = useSiteCountryCode();
  return `/${countryCode}/businesses`;
}
